import React, { useEffect, useState } from "react";
import Content from "./Content";
import Footer from "./Footer";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import "Benchmarking/Scss/Layout.scss";
import { useNavigate } from "react-router-dom";

const LayoutBenchmarking = () => {
  const path = window.location.pathname.split("/")[2];
  const [entity, setEntity] = useState();
  const navigate = useNavigate();
  useEffect(() => {
    if (path == undefined || path == "") {
      navigate("/benchmarking/faculty/profile");
    }
  }, []);
  return (
    <div className="layout">
      <Navbar setEntity={setEntity} entity={entity} />
      <div className="sidebar-content">
        <Sidebar entity={entity} />
        <Content />
      </div>
      {/* <div className="left-layout">
        <Sidebar entity={entity} />
      </div>
      <div className="right-layout">
        {path !== "rank" && path !== "compare" && <Footer />}
      </div> */}
    </div>
  );
};

export default LayoutBenchmarking;
